<template>
  <div class="fab-wrapper">
    <v-speed-dial
      v-model="fab"
      :bottom="bottom"
      :right="right"
      direction="top"
      :transition="transition"
      class="inner-speed-dial"
      fixed
    >
      <template v-slot:activator>
        <FabButtonIcon :fab="fab" :fab-model="fab" :isOuter="false" />
      </template>
      <v-overlay opacity="0.5">
        <v-speed-dial
          v-model="fab"
          :bottom="bottom"
          :right="right"
          direction="top"
          :transition="transition"
          class="inner-speed-dial"
          fixed
          v-if="!shareLink"
        >
          <template v-slot:activator>
            <FabButtonIcon :fab="fab" :fab-model="fab" :isOuter="true" />
          </template>
          <div class="v-speed-dial__list">
            <FabOptionButton
              title="REQUEST"
              image="mdi-file-document-edit-outline"
              @fabOptionClicked="requestClicked"
            />
            <FabOptionButton title="SHARE" image="mdi-share" @fabOptionClicked="shareClicked" />
            <FabOptionButton
              title="UPLOAD"
              image="mdi-cloud-upload-outline"
              @fabOptionClicked="uploadClicked"
            />
          </div>
        </v-speed-dial>
      </v-overlay>
    </v-speed-dial>
    <SharingLink
      @shareOptionClicked="shareLink = !shareLink"
      v-if="shareLink"
      :user-email="userEmail"
      :user-name="userName"
      :user-id="userId"
    />
  </div>
</template>

<script>
import FabButtonIcon from './fabbtn-icon.vue'
import FabOptionButton from './fab-options-btn.vue'
import SharingLink from './sharingLink.vue'
import Utils from '../../utils/index'

export default {
  name: 'FabBtn',
  components: {
    FabButtonIcon,
    FabOptionButton,
    SharingLink
  },
  props: {
    userEmail: {
      type: String,
      default: ''
    },
    userName: {
      type: String,
      default: ''
    },
    userId: {
      type: String,
      default: ''
    }
  },
  methods: {
    requestClicked() {
      Utils.manageProfileRouting({
        path: 'requests/flow/search-facility',
        route: this.$route,
        router: this.$router
      })
    },
    shareClicked() {
      this.shareLink = true
    },
    uploadClicked() {
      Utils.manageProfileRouting({
        path: 'upload',
        route: this.$route,
        router: this.$router
      })
    },
  },
  data() {
    return {
      shareLink: false,
      fab: false,
      right: true,
      bottom: true,
      transition: 'slide-y-reverse-transition'
    }
  }
}
</script>

<style scoped>
.v-speed-dial__list {
  align-items: center;
  display: flex;
  justify-content: center;
  padding: 0;
  position: absolute;
}

.v-speed-dial--bottom {
  bottom: 80px;
}

.v-speed-dial--right {
  right: 40px;
}

.inner-speed-dial {
  position: fixed;
}
.fab-wrapper {
  display: none;
}
@media only screen and (max-width: 561px) {
  .fab-wrapper {
    display: flex;
  }
}
</style>
